module.exports = __webpack_public_path__ + "img/company8.d0c84f86.png";